import { LinkRegistrationModelKo } from 'Content/ts/Models/Account/LinkRegistrationModel';
import { RegistrationConfirmationDetailsModel } from 'Content/ts/Models/Account/RegistrationConfirmationDetailsModel';
import { RegistrationResultModel } from 'Content/ts/Models/Account/RegistrationResultModel';
import CheckEmailForMemberResponseModel from 'Content/ts/Models/Account/CheckEmailForMemberResponseModel';
import { RateLimitAjaxService } from 'Content/ts/Shared/rate-limit-ajax-service';
import { RecaptchaService } from 'Content/ts/Recaptcha/recaptchaService';
import * as localisationHelper from 'localisationHelper';

import * as $ from 'jquery';
import * as q from 'q';
import * as globalConfig from 'globalConfig';
import * as ko from 'knockout';

class RegistrationService {

    constructor() {

    }

    register(request: LinkRegistrationModelKo): Q.Promise<RegistrationResultModel> {
        var op = q.defer <RegistrationResultModel>();

        RecaptchaService.performRecaptchaCheck((token) => {
            RateLimitAjaxService.ajax<RegistrationResultModel>({
                type: 'POST',
                url: globalConfig.Urls.Registration.Register,
                data: {
                    Email: request.Email(),
                    Password: request.Password(),
                    Password2: request.ConfirmPassword(),
                    Terms: true,
                    recaptchaResponse: token
                }
            }).then((result) => {
                op.resolve(result);
            }).fail(e => {
                op.reject(e);
            });
        }, () => {
            op.reject(localisationHelper.getString('GenericResources', 'RecaptchaValidationFailed'));
        });

        return op.promise;
    }

    confirmRegistration(request: RegistrationConfirmationDetailsModel): Q.Promise<RegistrationResultModel> {
        const unwrappedRequest = ko.toJS(request);

        return q($.ajax({
            type: 'POST',
            url: globalConfig.Urls.Registration.ConfirmRegistration,
            data: {
                Email: unwrappedRequest.Email,
                RegistrationKey: unwrappedRequest.RegistrationKey,
                Password: unwrappedRequest.Password,
                MemberNumber: unwrappedRequest.MemberNumber,
                Postcode: unwrappedRequest.Postcode,
                PhoneNumber: unwrappedRequest.PhoneNumber,
                DateOfBirth: unwrappedRequest.DateOfBirth ? unwrappedRequest.DateOfBirth.format() : null
            }
        }));
    }

    CheckEmailForMember(request: string): Q.Promise<CheckEmailForMemberResponseModel> {

        return RateLimitAjaxService.ajax({
            url: globalConfig.Urls.Account.CheckEmailForMember,
            method: "GET",
            dataType: "JSON",
            data: { email: request },
            cache: false
        });
    };
}

const service = new RegistrationService();
export { service as RegistrationService };